

exports.__esModule = true;
exports.$ReviewRoute = undefined;

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _angular = require('angular');

var _uiRouter = require('uiRouter');

require('xo-wallet-components/src/confirm-upop/route');

require('xo-login-components/src/onetouch-interstitial/route');

require('pages/xo-sidebar/route');

require('pages/xo-sidepage/route');

var _directive = require('./directive');

var _checkout = require('xo-models/src/checkout');

var _choice = require('xo-models/src/choice');

var _credit = require('xo-models/src/credit');

/* dynamic-import */

/* dynamic-import */
var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {

    path: 'review',
    directive: _directive.$xoReviewPageComponent,
    titleContent: 'memberReview.memberReviewTitle',
    params: { message: null },
    trackingData: {
        fptiState: 'review',
        templateName: 'memberReview.dust',
        pageGoal: 'Payment Review',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-review',
                'pagename2': '%::fullpage-review:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    resolve: {
        action: function action() {

            // Determine if we should instead route to the selectFi choice experiment page
            if (!(0, _squid.$feature)('choiceExperiment')) {
                return;
            }

            var _$config$choiceExperi = _squid.$config.choiceExperiment;
            _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
            var _$config$choiceExperi2 = _$config$choiceExperi.selectFi,
                fiPageVariants = _$config$choiceExperi2 === undefined ? [] : _$config$choiceExperi2,
                _$config$choiceExperi3 = _$config$choiceExperi.skipSelectFi,
                skipFiPageVariants = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3;
            var fromState = _uiRouter.$state.fromState,
                toParams = _uiRouter.$state.toParams;

            var skipStates = ['checkout.review', 'checkout.selectFi', 'checkout.authorizationmessage', 'checkout.pageAddCard.addCardFlow.addCard', 'checkout.chooseCreditOffer'];

            // Is review route hit a result of CREDIT_CARD_AUTH_FAILED, i.e. smart $x auth check failure?
            var isFromCcAuthFailure = toParams && toParams.message === 'CREDIT_CARD_AUTH_FAILED';
            if (!isFromCcAuthFailure && (!fromState.name ||
            // Current state contains one of the skip states (can be nested)
            skipStates.some(function (state) {
                return fromState.name.indexOf(state) !== -1;
            }))) {
                return;
            }

            // If returning from credit application, skip the selectFi page
            var isCapeReturnKey = _credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey();

            if (isCapeReturnKey) {
                return;
            }

            return _choice.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // Check if variant is selectFi variant
                if (fiPageVariants.indexOf(variant) === -1) {
                    return;
                }

                var models = {};

                // Check that there is more than one plan to choose from, or that plan is not preferred
                return (0, _squid.$populate)(models, {
                    checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                    checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token)
                }).then(function () {
                    /**
                     * instant update callback which is making external api calls
                     * to get shipping charge and same is getting updated into checkout session (patch call)
                     * selectFI page is updating the plan id from initial post on checkout session
                     * but because of patch call for shipping charge old plan id is not valid
                     * and the update to PAPS resulted in internal error
                     * skip the choice page if it is instant update flow
                     */
                    if (models.checkoutCart.get('instantUpdateIntegration')) {
                        return;
                    }

                    var plans = models.checkoutSession.get('fundingOptions.plans');
                    var isPreferredDefault = skipFiPageVariants.indexOf(variant) > -1 && plans && plans[0].primaryFs.isPreferred;
                    var stickyPlans = models.checkoutSession.futurePaymentInstruments;

                    if (!isPreferredDefault && (plans && plans.length > 1 || stickyPlans && stickyPlans.length > 1)) {
                        return {
                            to: 'checkout.selectFi',
                            newState: true
                        };
                    } else {
                        _logger.$logger.info('skip_selectFi', {
                            reason: isPreferredDefault ? 'default_is_preferred' : 'not_enough_plans'
                        });
                        return;
                    }
                });
            });
        }
    },

    children: [{
        name: '$SidebarRoute',
        attributes: {
            'back-uri': 'backUri',
            'shipping-change-feature': 'shippingChangeFeature',
            'promotion': 'promotion',
            'update': 'update',
            'token': 'token',
            'installment': 'installment',
            'strict-address-normalization': 'strictAddressNormalization',
            'shipping-address': 'shippingAddress',
            'on-address-normalized': 'onAddressNormalized'
        },
        lazyRoute: 'pages/xo-sidebar/route',
        slug: 'sidebar'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token',
            'on-complete': 'onComplete'
        },
        lazyRoute: 'xo-login-components/src/onetouch-interstitial/route',
        slug: 'oneTouchUpsell'
    }, {
        name: '$xoConfirmUpopRoute',
        props: function props() {
            var props = {
                token: this.token,
                cardmodel: this.cardModel
            };

            if (this.upopCallbacks.isOnUpdate) {
                props.onSuccess = this.upopCallbacks.onUpdateSuccess;
                props.onCancel = this.upopCallbacks.onUpdateCancel;
            } else {
                props.onSuccess = this.upopCallbacks.onConfirmUpopSuccess;
                props.onCancel = this.upopCallbacks.onConfirmUpopCancel;
            }

            return props;
        },

        lazyRoute: 'xo-wallet-components/src/confirm-upop/route',
        slug: 'confirmUpop'
    }, {
        name: '$SidepageRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-sidepage/route',
        slug: 'sidepage'
    }]
}); /* dynamic-import */
/* dynamic-import */


angular.value("$ReviewRoute", $ReviewRoute);
_logger.$logger;

_squid.$ComponentRoute;

_squid.$feature;

_squid.$config;

_squid.$populate;

_angular.$rootScope;

_uiRouter.$state;

_directive.$xoReviewPageComponent;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_choice.$ChoiceEligibility;

_credit.$CreditDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/route.js
// module id = ./pages/xo-review/route.js
// module chunks = 0